import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const KeyboardReturnIcon: React.FC<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z" />
  </SvgIcon>
);

export default KeyboardReturnIcon;
